// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"PlaybackRateDropdown-module__dropdownMenu___zDldQ","toggle":"PlaybackRateDropdown-module__toggle___D-OKj"};